import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './Club.css';
import {
	BannerReportView
} from './Admin';
import { ChangePictureIcon, BannerShimmer, FeedBackPopUp, AngularTemplateView, EmptyState, LoadingState, PostItem, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, SetTournGameModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView } from '.././components/Common';

import EventView from '.././components/Event';
import AboutView from '.././components/About';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import Games from '.././components/Games';
import Settings from '.././components/Settings';
import Teams from '.././components/Teams';
import Training from '.././components/Training';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';
import ApplicationForm from '../components/ApplicationForm';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

class Institution extends Component {
    constructor(p) {
        super(p)
        this.state = {
            id: this.props.match.params.id,
            institution: { id: null, teams: { current: [] } },
            error: false,
            activeTab: 'teams',
            tabs: this.props.withGuest ? [
                { val: "about", key: "About", notices: [] },
                { val: "apply", key: "Apply", notices: [] }
            ] : [
                    { val: "timeline", key: "Timeline", notices: [] },
                    { val: "games", key: "Games", notices: [] },
                    { val: "about", key: "About", notices: [] },
                    { val: "apply", key: "Apply", notices: [] },
                    { val: "teams", key: "Teams", notices: [] },
                    { val: "photos", key: "Photos", notices: [] },
                    { val: "videos", key: "Videos", notices: [] },
                    //{ val: "training", key: "Training", notices: [] },
                    { val: "events", key: "Events", notices: [] },
                    { val: "notice", key: "Notifications", notices: [] },
                    { val: "settings", key: "Settings", notices: [] }
                ],
            offset: 0,
            posts: [],
            isLoadingPosts: true,
            events: [],
            yourPhotos: [],
            photosOfYou: [],
            albums: [],
            yourVideos: [],
            videosOfYou: [],
            limit: 30,
            seesions: [],
            seesionFiles: []
        }

        this.onScroll = this.onScroll.bind(this)
        this.setTab = this.setTab.bind(this)
        this.onPostAdded = this.onPostAdded.bind(this)
    }

    componentWillMount() {
        FakeData.mountState("institution", true)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        const _that = this;
        const _type = "I"
        const _list = FakeData.getBlocked({ props: {} }, true, [_type]);
        const system = _list.BlockedBySystem.filter((item, i) => {
            return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
        })

        const by_you = _list.BlockedByYou.filter((item, i) => {
            return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
        })

        const for_you = _list.BlockedForYou.filter((item, i) => {
            return (item.username === this.props.match.params.id || item.user_id === this.props.match.params.id) && item.user_type === _type;
        })

        const final_array = system.concat(for_you, by_you);
        const username_array = [];
        final_array.forEach((item, i) => {
            username_array.push(item.username)
            username_array.push(item.user_id)
        })

        const _isBlocked = (FakeData.inArray(this.props.match.params.id, username_array)) ? true : false;
        if (_isBlocked) {
            _that.setState({
                error: true,
                user: { error: true }
            });
        } else {
            this.getProfile()
            //this.getPosts()
            this.getEvents()
            this.getStyle(this.props.match.params.id)

            this.getYourPhotos()
            this.getPhotosOf()
            this.getVideoOf()
            this.getYourVideos()
            this.getSessions()
            document.querySelector("#root").addEventListener('scroll', this.onScroll);
            var params = FakeData.getQueries(this.props.location.search);
            this.setState({ activeTab: this.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about" });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
            const _that = this
            FakeData.mountState("institution", false)
            this.setState({
                institution: { id: null },
                id: nextProps.match.params.id
            });

            setTimeout((() => {
                FakeData.mountState("institution", true)
                _that.getProfile()
                //_that.getPosts()
                _that.getEvents()
                _that.getStyle(nextProps.match.params.id)
                _that.getYourPhotos()
                _that.getPhotosOf()
                _that.getVideoOf()
                _that.getYourVideos()
                var params = FakeData.getQueries(_that.props.location.search);
                _that.setState({ activeTab: _that.props.withGuest ? "about" : (params.sInit) ? params.sInit : "about" });
            }), 1000)

            return true;
        }

        return true
    }

    componentWillUnmount() {
        FakeData.mountState("institution", false)
        //window.removeEventListener('scroll', this.onScroll);
        
        document.querySelector("#root").removeEventListener('scroll', this.onScroll);
        const s = new Trojan.style("league").kill()
    }

    getStyle(id) {
        const _that = this
        if (!FakeData.isMounted("institution")) {
            return
        }
        FakeData.post("/getTeamStyle.php?auth0", { teamId: id, table: "institution", field: "InstitutionHashID" }, {
            success: ((res) => {
                const style = res
                const s = new Trojan.style("league").declare(style).run()
                _that.getStyleID = setTimeout((() => {
                    _that.getStyle(_that.props.match.params.id)
                }), 5000)
            }),
            error: ((err) => {
            })
        })
    }

    getProfile() {
        const _that = this;
        let dataTo = {

        };

        if (this.props.withGuest) {
            dataTo = {
                user: FakeData.guest,
                InstitutionID: this.props.match.params.id
            }
        } else {
            dataTo = {
                user: FakeData.getData('yoo'),
                InstitutionID: this.props.match.params.id
            }
        }

        if (!FakeData.isMounted("institution")) {
            return
        }

        //console.log(dataTo)

        FakeData.post("/getInstitutionProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }

                if (res.error) {
                    _that.setState({
                        error: true,
                        institution: res
                    });
                } else {
                    if (!_that.props.withGuest) _that.state.tabs[8].notices = _that.getUnreadNotices(res.join_received)
                    const _user = res;
                    _user.type = "I"
                    FakeData.setData("user", _user);
                    var params = FakeData.getQueries(_that.props.location.search);
                    _that.setState({
                        institution: res,
                        tabs: _that.state.tabs,

                    });
                }
                FakeData.setData("institution", res)
                setTimeout((() => {
                    _that.getProfile()
                }), 5000)
            }),
            error: ((err) => {
                _that.setState({
                    error: true,
                    institution: {error:true}
                });
            })
        })
    }

    getPosts() {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I"
            },
            clubs: [],
            leagues: [],
            teams: [],
            limit: this.state.limit
        }

        if (!FakeData.isMounted("institution")) {
            return
        }

        FakeData.post("/getPosts.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                _that.setState({
                    posts: res,
                    isLoadingPosts: false
                })

                _that.getPostsID = setTimeout((() => {
                    _that.getPosts()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getEvents() {
        const _that = this
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: this.state.institution.id,
            userToType: "I",
            teamIds: this.getTeamIds(this.state.institution)
        }

        if (!FakeData.isMounted("institution")) {
            return
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })
                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                
            })
        })
    }

    getSessions = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I",
            }
        }

        FakeData.post("/getSessions.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                _that.setState({
                    sessions: res
                })

                setTimeout((() => {
                    _that.getSessions()
                }), 15000)
            }),
            error: ((res) => {
                
                setTimeout((() => {
                    _that.getSessions()
                }), 10000)
            })
        })
    }

    getTeamIds = (club) => {
        const list = [];
        if (club.id === null) {
            return list;
        }
        const { current } = club.teams
        FakeData.listify(current).forEach((item, i) => {
            if (!FakeData.inArray(item.id, list)) {
                list.push(item.id)
            }
        })
        return list;
    }

    getYourPhotos() {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I",
            }
        }

        FakeData.post("/getPhotos.php?auth0&yours", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }

                //console.log(res)
                _that.setState({
                    yourPhotos: res
                })

                FakeData.setData("institution_pics", res)

                setTimeout((() => {
                    _that.getYourPhotos()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getPhotosOf() {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I",
            }
        }

        FakeData.post("/getPhotos.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                _that.setState({
                    photosOfYou: res
                })

                setTimeout((() => {
                    _that.getPhotosOf()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getYourVideos() {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I",
            }
        }

        FakeData.post("/getVideos.php?auth0&yours", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                _that.setState({
                    yourVideos: res
                })

                FakeData.setData("institution_vids", res)

                setTimeout((() => {
                    _that.getYourVideos()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getVideoOf() {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.institution.id,
                type: "I",
            }
        }

        FakeData.post("/getVideos.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("institution")) {
                    return
                }
                _that.setState({
                    videosOfYou: res
                })

                setTimeout((() => {
                    _that.getVideoOf()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    setTab(item) {
        this.setState({
            activeTab: item.val
        })
    }

    onScroll(e) {
        this.setState({
            offset: document.querySelector("#root").scrollTop
        });
    }

    onPostAdded(post) {
        //console.log(this.state.posts.length);
        this.state.posts.unshift(post)
        this.setState({
            posts: this.state.posts
        });

        //console.log(this.state.posts.length);
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getTeamIds = () => {
        const teams = FakeData.listify(this.state.institution.teams.current);
        const list = [];
        teams.forEach((item, i) => {
            list.push(item.id)
        })

        return list
    }

    render() {
        if (this.state.institution.id == null && !this.state.institution.error) {
            return (
                <BannerShimmer />
            );
        }
        if(this.state.institution.error){
            return(
              <Redirect to={{
                pathname: "/account_error",
                
              }} />
            )
          }
        const { withGuest, user } = this.props;
        if (withGuest) {
            return (
                <div className="tabs team row main_content sp-flex-width" style={{ zIndex:0, padding: "10px 10px" }}>
                    <Helmet
                        title={this.state.institution.name}
                        meta={[
                            { "name": "description", "content": "Description of page" },
                            { property: "og:type", content: "profile" },
                            { property: "og:title", content: this.state.institution.name },
                            { property: "og:image", content: this.state.institution.image },
                            { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
                        ]}
                    />
                    <ClubBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} institution={this.state.institution} {...this.props} pictures={this.state.yourPhotos} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
                    {((this.state.activeTab != "training") /*&& (this.state.activeTab != "events")*/) &&
                        <LeagueSplitView  BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou}class="league" profile={this.state.institution} offset={this.state.offset}>
                            {this.state.activeTab !== "apply" &&
                                <div>
                                    <AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.institution} type="I" state="institution" />
                                </div>
                            }
                            {this.state.activeTab == "apply" &&
                                <ApplicationForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={FakeData.guest} {...this.props} withGuest={withGuest} isTeam={false} team={this.state.institution} type={"I"} />
                            }
                        </LeagueSplitView>
                    }
                </div>
            );
        }
        return (
            <div className="tabs team row main_content sp-flex-width" style={{ zIndex:0, padding: "10px 10px" }}>
                <Helmet
                    title={this.state.institution.name}
                    meta={[
                        { "name": "description", "content": "Description of page" },
                        { property: "og:type", content: "institution.profile" },
                        { property: "og:title", content: this.state.institution.name },
                        { property: "og:image", content: this.state.institution.image },
                        { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
                    ]}
                />
                <ClubBanner BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} institution={this.state.institution} pictures={this.state.yourPhotos} activeTab={this.state.activeTab} tabs={this.state.tabs} onTabSelect={this.setTab} />
                {((this.state.activeTab != "training") /*&& (this.state.activeTab != "events")*/) &&
                    <LeagueSplitView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} class="league" profile={this.state.institution} offset={this.state.offset}>
                        {this.state.activeTab == "timeline" &&
                            <div>
                                <GlobalTMForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.institution} words={()=>{
                const _settings = FakeData.listify(this.state.institution.settings).filter((set, i)=>{
                  return set.sub === "word_restrition"
                });

                if(_settings[0]){
                  return FakeData.nullify(_settings[0]['value']).split(",");
                } else{
                  return []
                }
              }} isAdmin={this.state.institution.isAdmin} onPostAdded={this.onPostAdded} postToType="I" postToId={this.state.institution.id} postToName={this.state.institution.name} postToImage={this.state.institution.image} />
                                <GlobalTMFeeds BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.institution}
                    postToType="I" words={()=>{
                const _settings = FakeData.listify(this.state.institution.settings).filter((set, i)=>{
                  return set.sub === "word_restrition"
                });

                if(_settings[0]){
                  return FakeData.nullify(_settings[0]['value']).split(",");
                } else{
                  return []
                }
              }} page={{ id: this.state.institution.id, type: "I" }} teams={[]} clubs={[]} leagues={[]} institutions={[]} user={(this.state.institution.isAdmin) ? this.state.institution : FakeData.getData("yoo")} userType={(this.state.institution.isAdmin) ? "I" : "F"} posts={this.state.posts}>
                                    <EmptyState style={{ background: "#fff" }} isShown={(FakeData.listify(this.state.posts).length === 0 && !this.state.isLoadingPosts) ? true : false} text="No posts were found!" icon="filter_hdr" />
                                    <LoadingState style={{ background: "#fff" }} isShown={this.state.isLoadingPosts} text={"Loading"} />
                                </GlobalTMFeeds>
                            </div>
                        }
                        {this.state.activeTab == "games" &&
                            <Games BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} teams={this.getTeamIds()} league={false} />
                        }
                        {this.state.activeTab == "notice" &&
                            <InternalNoticeCenter BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} notices={this.state.institution.join_received} profile={this.state.institution} type={"I"} />
                        }
                        {this.state.activeTab == "teams" &&
                            <Teams BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} contentId={this.state.institution.id} content={this.state.institution} contentType={"I"} sports={FakeData.listify(this.state.institution.sports)} teams={this.state.institution.teams} isAdmin={this.state.institution.isAdmin} />
                        }
                        {this.state.activeTab == "videos" &&
                            <Videos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.institution) ? this.state.institution : FakeData.getData("yoo")} userType={(this.state.institution.isAdmin) ? "I" : "F"} author={this.state.institution.name} data={{ uploads: this.state.yourVideos, tagged: this.state.videosOfYou }} isAdmin={this.state.institution.isAdmin} />
                        }
                        {this.state.activeTab == "photos" &&
                            <Photos BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} user={(this.state.institution) ? this.state.institution : FakeData.getData("yoo")} userType={(this.state.institution.isAdmin) ? "I" : "F"} author={this.state.institution.name} data={{ uploads: this.state.yourPhotos, tagged: this.state.photosOfYou, albums: this.state.albums }} isAdmin={this.state.institution.isAdmin} />
                        }
                        {this.state.activeTab == "apply" &&
                            <ApplicationForm BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={FakeData.getData("yoo")} {...this.props} isTeam={false} team={this.state.institution} type={"I"} />
                        }
                        {this.state.activeTab == "settings" &&
                            <Settings BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.institution} settings={[
                                "General",
                                "Messaging",
                                "Post Attribution",
                                "Notifications",
                                "Videos",
                                "SPAM",
                                "Page Roles"
                              ]} type="I" state="institution" />
                        }
                        {this.state.activeTab == "about" &&
                            <div>
                                <AboutView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} profile={this.state.institution} type="I" state="institution" />
                            </div>
                        }
                        {(this.state.activeTab == "events") &&
                            <EventView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} viewEvents={true} eventToType="I" eventToID={this.state.institution.id} events={this.state.events} profile={this.state.institution} />
                        }
                    </LeagueSplitView>
                }

                {(this.state.activeTab == "training") &&
                    <Training BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} sessions={this.state.sessions} files={this.state.sessionFiles} user={this.state.institution} userType={"I"} />
                }
            </div>
        );
    }
}

class ClubBanner extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            croppieEl: null,
            isCropping: false,
            croppie: {},
            isCroppingCover: false,
            img: this.props.institution.cropped,
            originalImg: this.props.institution.image
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.isCropping || !this.state.isCroppingCover) {
            this.setState({ originalImg: nextProps.institution.image, img: nextProps.institution.cropped });
        }
    }

    componentWillMount() {
        const croppie = Croppie
    }

    setRef() {
        const _that = this
        this.setState({ isCropping: true })
        setTimeout(() => {
            const opts = {
                viewport: {
                    width: 200,
                    height: 200,
                    type: 'circle'
                },
                enforceBoundary: false,
                boundary: {
                    width: 300,
                    height: 300
                }
            }

            const el = ReactDOM.findDOMNode(_that.el);
            const elem = $(el)[0];
            //console.log(elem);
            var c = new Croppie(elem, opts);

            c.bind({
                url: _that.state.originalImg
            })

            _that.croppie = c
        }, 500)
    }

    setRefCover() {
        const _that = this
        this.setState({ isCropping: true })
        setTimeout(() => {
            const opts = {
                viewport: {
                    width: 420,
                    height: 420,
                },
                enforceBoundary: false,
                boundary: {
                    width: 420,
                    height: 420
                }
            }

            const el = ReactDOM.findDOMNode(_that.elCover);
            const elem = $(el)[0];
            //console.log(elem);
            var c = new Croppie(elem, opts);

            c.bind({
                url: _that.state.originalImg
            })

            _that.croppieToo = c
        }, 500)
    }

    saveCrop() {
        const _that = this
        const opts = {
            type: "base64",
            format: "png",
            size: "original"
        }
        this.croppie.result(opts).then((res) => {
            _that.uploadCropped(res)
        }).catch((err) => {
            10000
        })
    }

    uploadCropped(data) {
        console.log("jkhjhj");
        const _that = this
        const dataTo = {
            data: data,
            id: this.props.institution.id,
            table: "clubs"
        }

        FakeData.post("/uploadCroppedImg.php?auth0", dataTo, {
            success: ((res) => {
                if (!res.error) {
                    _that.setState({
                        img: data,
                        isCropping: false
                    });
                } else {
                    _that.setState({
                        img: _that.state.originalImg,
                        isCropping: false
                    });
                }


                _that.croppie.destroy()
            }),
            error: ((err) => {

            })
        })
    }

    getRGB(b) {
        var a;
        if (b && b.constructor == Array && b.length == 3) {
            return b;
        }

        if (a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b)) {
            return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
        }

        if (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(b)) {
            return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
        }

        if (a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b)) {
            return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
        }

        if (a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b)) {
            return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
        }

        return (typeof (a) != "undefined") ? a[jQuery.trim(b).toLowerCase()] : null
    };

    luminance_get(color) {
        var rgb = this.getRGB(color);
        if (!rgb) {
            return null;
        }
        return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
    }

    getSelectedColor(color) {
        var val = (this.luminance_get(color) > 180) ? "#000" : "#fff"
        const dataTo = {
            bg: color,
            txt: val,
            id: this.props.institution.id,
            table: "institution"
        }

        const _that = this

        FakeData.post("/setColors.php?auth0", dataTo, {
            success: ((res) => {

            }),
            error: ((err) => {

            })
        })
    }

    getFilteredNotices = (arr, data) => {
        const list = [];
        FakeData.listify(data).forEach((item, i) => {
            if (FakeData.inArray(item.actionData.context, arr)) {
                list.push(item)
            }
        })

        return list
    }

    like() {
        const dataTo = {
            user: FakeData.getData("yoo"),
            type: "I",
            contentId: this.props.institution.id,
            userOne: { id: this.props.institution.id, type: "I" },
            userTwo: null,
            users: this.props.institution.roles,
            userType: "F"
        }
        const _that = this

        FakeData.post('/likeContent.php?auth0', dataTo, {
            success: ((res) => {
                FakeData.alert("Done!");
            }),
            error: ((err) => {

            })
        }, true, "", () => { })
    }

    addToShortcuts() {
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            contentType: "I",
            contentId: this.props.institution.id,
            contentName: this.props.institution.name,
            contentRef: this.props.institution.hash,
            contentSearch: "?sInit=about",
            userType: "F"
        }

        const _that = this

        FakeData.post('/createShortcut.php?auth0', dataTo, {
            success: ((res) => {
                FakeData.alert("Done!");
            }),
            error: ((err) => {

            })
        }, true, "", () => { })
    }

    render() {
        return (
            <div className="team-banner" style={{width: FakeData.width, zIndex:0, overflowY: 'hidden'}}>
                {this.props.institution.isAdmin &&
                    <BannerReportView type={"I"} id={this.props.institution.id} />
                }
                {this.props.institution.isAdmin &&
                    <div className="team-banner-edit">
                        {!this.state.isCropping && this.is &&
                            <i className="material-icons" onClick={() => this.setRef()}>create</i>
                        }
                        {this.state.isCropping &&
                            <i className="material-icons" onClick={() => this.setState({ isCropping: false })}>close</i>
                        }
                        {this.state.isCropping &&
                            <i className="material-icons" onClick={() => this.saveCrop()}>save</i>
                        }
                        {!this.state.isCropping &&
                            <i className="material-icons">format_color_fill<input onChange={(e) => this.getSelectedColor(e.target.value)} type="color" style={{ width: "12px", height: "12px", marginLeft: "-15px", opacity: 0 }} /></i>
                        }
                    </div>
                }
                <div className="team-banner-info" style={{ marginTop: ((this.props.institution.isAdmin) ? "-16px" : "") }}>
                    {this.state.isCropping &&
                        <div ref={(c) => { this.el = c }} className="team-banner-info-logo">

                        </div>
                    }
                    {!this.state.isCropping &&
                        <div className="team-banner-info-logo">
                            <img src={this.state.originalImg} />
                            {this.props.institution.isAdmin &&
                                <div className="front-photo">
                                    <ChangePictureIcon toType="I" pictures={this.props.pictures} type="Logo" idField={"InstitutionID"} table={"institution"} field={"Logo"} page="institution" toId={this.props.institution.id} pictureForType="I" />
                                </div>
                            }
                        </div>
                    }
                    <div className="team-banner-info-content">
                        <h2>{this.props.institution.name}</h2>
                        <ul>
                            {((this.props.institution.website !== "")) &&
                                <li><img src={(this.props.institution.color == "#fff") ? ".././images/website_icon_wht.svg" : ".././images/website_icon.svg"} /><span>{this.props.institution.website}</span></li>
                            }
                            {((this.props.institution.contactMain !== "")) &&
                                <li><img src={(this.props.institution.color == "#fff") ? ".././images/mobile_icon_wht.svg" : ".././images/mobile_icon.svg"} /><span>{this.props.institution.contactMain}</span></li>
                            }
                            {((this.props.institution.email !== "")) &&
                                <li><img src={(this.props.institution.color == "#fff") ? ".././images/email_icon_wht.svg" : ".././images/email_icon.svg"} /><span>{this.props.institution.email}</span></li>
                            }
                            {((this.props.institution.address !== "")) &&
                                <li><img src={(this.props.institution.color == "#fff") ? ".././images/checkin_icon_wht.svg" : ".././images/checkin_gry.svg"} /><span>{this.props.institution.address}</span></li>
                            }
                        </ul>
                        <div className="club-banner-sports">
                            {
                                this.props.institution.sports.map((i, x) => {
                                    return (
                                        <img key={x} src={i.image} />
                                    )
                                })
                            }
                        </div>
                        {!this.props.withGuest &&
                            <div className="action-buttons">
                                {(!this.props.institution.hasShortcut && this.props.institution.isAdmin) && <div onClick={this.addToShortcuts.bind(this)}><i className="material-icons">add</i>Add to shortcuts</div>}
                                {!this.props.institution.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_up</i>Like</div>}
                                {this.props.institution.isLiked && <div onClick={this.like.bind(this)}><i className="material-icons">thumb_down</i>Unlike</div>}
                                {!this.props.institution.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in</i>Follow</div>}
                                {this.props.institution.isFollewed && <div onClick={() => { }}><i className="material-icons">turned_in_not</i>Unfollow</div>}
                                {!this.props.institution.isAdmin &&
                                    <div onClick={() => {
                                        const chat = this.props.institution.convo?this.props.institution.convo:{
                                        otherUser: {
                                            id: this.props.institution.id,
                                            type: "I",
                                            ...this.props.institution
                                        },
                                        id: null,
                                        userOne: FakeData.getData("yoo"),
                                        userTwo: {
                                            id: this.props.institution.id,
                                            type: "I",
                                            ...this.props.institution
                                        },
                                        messages: [],
                                        last_msg: null,
                                        unread: 0,
                                        isYou: true,
                                        date: null,
                                        removedByUserOne: false,
                                        removedByUserTwo: false,
                                        type: "timeline",
                                        target: "new"
                                        }

                                        FakeData.shared("mainThread").addToChats(chat)
                                    }}><i className="material-icons">chat</i>Message</div>
                                }
                                <div>
                                    <FeedBackPopUp isBanner={true} userTo={{
                                        id: FakeData.getData("yoo").id,
                                        type: "F"
                                    }} user={{
                                        id: this.props.institution.id,
                                        type: "I"
                                    }} object={{
                                        id: this.props.institution.id,
                                        type: "I",
                                        content: this.props.institution.name,
                                        image: this.props.institution.image
                                    }} owner={{
                                        id: this.props.institution.id,
                                        type: "I",
                                        name: this.props.institution.name,
                                        user: this.props.institution.username,
                                        image: this.props.institution.image,
                                        email: this.props.institution.email,
                                        roles: this.props.institution.roles
                                    }} text={"More"} iconStyle={{
                                        margin: "0px 0px 0px 10px",
                                    }} icon={"more_horiz"} style={{
                                        display: 'flex'
                                    }} menus={this.props.institution.isAdmin ? {
                                        Setting: {
                                            label: "Timeline Settings", cb: () => {
                                                this.props.onTabSelect(
                                                    { val: "settings", key: "Settings", notices: [] }
                                                );
                                            }
                                        }
                                    } : {
                                            FeedBack: { label: "Report Profile", cb: () => { } },
                                            Block: { label: "Block", cb: () => { } }
                                        }} />
                                </div>
                            </div>
                        }
                    </div>
                    <div className="team-banner-info-cover">
                        <img src={this.state.originalImg} />
                        {this.props.institution.isAdmin && this.is &&
                            <i className="material-icons" style={{ marginRight: "60px", fontSize: "15px" }} onClick={() => this.setState({ isCroppingCover: true })}>edit</i>
                        }
                        {this.props.institution.isAdmin &&
                            <div className="back-photo">
                                <ChangePictureIcon toType="I" pictures={this.props.pictures} type="CoverPicture" idField={"InstitutionID"} table={"institution"} field={"CoverPicture"} page="institution" toId={this.props.institution.id} pictureForType="I" />
                            </div>
                        }
                    </div>
                </div>
                <div className="team-banner-nav">
                    {
                        this.props.tabs.map((item, i) => {
                            if (FakeData.inArray(item.val, ["notice", "training", "events", "settings"]) && !this.props.institution.isAdmin) {
                                return null;
                            }
                            return (
                                <div className={(this.props.activeTab == item.val) ? "active" : ""} key={i} onClick={() => this.props.onTabSelect(item)}>
                                    {item.key}
                                    {(item.notices.length > 0 && this.props.institution.isAdmin) &&
                                        <div className="notices-badge">
                                            {this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length > 0 &&
                                                <span className="events">{this.getFilteredNotices(["event_invite", "event_admin_invite", "event_accept"], item.notices).length}</span>
                                            }
                                            {this.getFilteredNotices([], item.notices).length > 0 &&
                                                <span className="_training">{this.getFilteredNotices([], item.notices).length}</span>
                                            }
                                            {this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length > 0 &&
                                                <span className="games">{this.getFilteredNotices(["game_invite", "game_accept"], item.notices).length}</span>
                                            }
                                            <span className="all">{item.notices.length}</span>
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Institution;


// WEBPACK FOOTER //
// ./src/pages/Institution.js